import { render, staticRenderFns } from "./EditMgtGeneral.vue?vue&type=template&id=101cfa56&"
import script from "./EditMgtGeneral.vue?vue&type=script&lang=js&"
export * from "./EditMgtGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports